import * as React from "react";
import styled, { keyframes } from "styled-components";
const wheelAnimation = keyframes `
    0% { 
        transform: translate3d(0px, 0px, 0px);
        opacity: 1;
    }
    50% {
        transform: translate3d(0px, 15px, 0px);
        opacity: 1;
    }
    100% {
        transform: translate3d(0px, 15px, 0px);
        opacity: 0;
    }
`;
const SVG = styled.svg.withConfig({ displayName: "SVG", componentId: "sc-az7fjv" }) `
    stroke: currentColor;
    stroke-width: 2px;
    stroke-linejoin: round;
    stroke-linecap: round;
    fill: none;

    > line {
        animation: ${wheelAnimation} 3.5s infinite;
    }
`;
export const ScrollIcon = (props) => (React.createElement(SVG, { className: props.className, viewBox: "-1 -1 32 87", width: "32", height: "77" },
    React.createElement("rect", { x: "0", y: "0", rx: "15", ry: "15", width: "30", height: "55" }),
    React.createElement("line", { x1: "15", y1: "8", x2: "15", y2: "15" }),
    React.createElement("path", { d: " M 6 64 L 15 73 L 24 64" })));
